module.exports = __webpack_public_path__ + "static/campfire-zoom-9facd40f4e958137e6ca82d087b103d7.jpg";